import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { busLookups, busLookupsModuleCode, lookupStatus } from '@core/enums/bus-Lookup';
import { AuthService } from '@core/services/auth.service';
import { User } from '@core/model/user/user';
import { ImageResizeService } from '@shared/services/image-resize.service';
import { IFileUpload, NoteAttachments, Notes } from '@core/model/note/note';
import { PageResult } from '@core/model/pagination/page-result';
import { States, TicketStatusChange } from '@generated/queries';
import {SystemObject, UserAction } from '@shared/services/message-params';
import { Observable, map } from 'rxjs';
import { PageFilterHrLookup, PageFilter } from '@core/model/pagination/filter';
import { BusLookup } from '@core/model/bus-lookup/bus-lookup';
import { BusLookupService } from '@core/services/bus-lookup.service';
import { NotifyService } from '@core/services/notify.service';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { LocationService } from '@shared/services/location.service';
import { UserService } from '@shared/services/user.service';
import { TktLookupService } from '../../../app/layout/pages/tickets-setup/service/tkt-lookup.service';
import { TicketStatusChangeService } from '../../../app/layout/pages/tickets/services/ticket-status-change.service';
import { NotesService } from '../note/services/notes.service';
import { PaginationNavigationComponent } from '../paginator/pagination-navigation/pagination-navigation.component';
import { AppRoles } from '@core/model/role/appRole';
import { FileService } from '@shared/services/file.service';
import { CommonModule } from '@angular/common';
import { OnInit } from '@angular/core';
import { SelectMultilevelComponent } from '../select-multilevel/select-multilevel.component';
import {AvatarComponent} from '@shared/components/avatar/avatar.component';
import { MatTooltip } from '@angular/material/tooltip';
import { GeoPosition } from '@shared/model/geoLocation';
import { FileExtension, FileMimeType } from '@shared/model/file-types';
import { BkButton } from '@brickclay-org/ui';
import { HNotesService } from '../h-notes/h-notes.service';
import {
  mapMongoNoteWithTicketStatusToDetail,
  MongoNoteDetail,
} from '../h-notes/h-notes.models';


type Tabs = 'Note' | 'Status';
@Component({
  selector: 'app-notes',
  imports: [
    CommonModule,
    BkButton,
    SelectMultilevelComponent,
    AvatarComponent,
    MatTooltip
  ],
  templateUrl: './notes.component.html',
  standalone: true,
  styleUrl: './notes.component.css',
})
export class NotesComponent implements OnInit, OnChanges {
  activeTab: Tabs = 'Status';
  form: FormGroup;
  busLookupModuleCode = busLookupsModuleCode.NoteType;
  currentUserNameLetter: string;
  isSaveBtnDisabled = false;
  @ViewChild('messageInput') messageInput: ElementRef<HTMLTextAreaElement>;
  @ViewChild('chatMessages') chatMessagesRef: ElementRef;
  @ViewChild('popupContainer') popupContainer!: ElementRef;
  ticketId=''
  @Input() objectID  = '';
  @Input() noteModuleCode: string;
  @Input() tableDivClass = 'h-450px';
  @Input() notePaddingClass = '';
  @Input() noteCardClass = 'card h-100';
  @Input() emitValues= false;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('listContainer') listContainer: ElementRef;
  @ViewChild('formBox') formBoxRef!: ElementRef;
  @Input() minHeight: number;
  @Input() notesTypeCode: string;
  @Input() isNoteType: boolean;
  @Input() isStatusDropDown: boolean;
  @Input() isFilterType: string;
  @Input() noteTypeVisibility: boolean;
  @Input() isSaveButton = true;
  @Input() isTextRequired = true;
  @Input() isTimeLineView = false;
  @Input() isDisplayEditButton = true;
  @Input() assigneeId = null;
  @Input() viewAll_Status_NoteType_Notes = false;
  @Input() isRefreshFromParent = false;
  @Input() heightClass = 'fixed_height';
  @Input() dropdownPositionClass = '';
  @Input() isManager = false;
  @Input() latestChangeStatus: TicketStatusChange;
  @Input() parentTimeZone: string;
  @Input() isDisplayCommentList = true;
  @Input() selectedCurrentStatusId: string;
  @Input() isCompleted: boolean;
  @Input() lookupCategoryCode: string;
  @Input() ChangeTicketStatusWrite: boolean;
//Output
  @Output() isNoteSaved = new EventEmitter<{ noteText: string }>();
  @Output() uploadFileEvent = new EventEmitter<boolean>();
  @Output() isChangeAvailable = new EventEmitter<boolean>(false);
  @Output() isTicketCompleted = new EventEmitter<boolean>(false);
  @Output() lastNote = new EventEmitter<Notes>();

  isFilter = false;
  startDate = '';
  endDate = '';
  search = '';
  createNoteSearch = '';

  colorsClass: string[] = [
    'bg_warning',
    'bg_info',
    'bg_primary',
  ];
  currentColorPickedIndex = 0;
  loopIndex = 0;
  isCompletedSelected = false;
  notes: Notes[] = [];
  mongoNotes: MongoNoteDetail[]=[]
  editNote: Notes = new Notes();
  notesText = '';
  lstFiles: File[] = [];
  fileToUpload: File | null = null;
  fileUploaded: IFileUpload = new IFileUpload();
  downloadFile: IFileUpload[] = [];
  lstUploadedFiles: IFileUpload[] = [];
  existingUploadedFiles: IFileUpload[] = [];
  resizedFiles: File[] = [];
  isuploadDocument: boolean;
  attachments: ['file1.pdf', 'image.jpg'];
  totalFileSize: number;
  editCheck:boolean;
  noteId: string;
  loading: boolean;
  filters: PageFilterHrLookup = {
    pageIndex: 0,
    activeIndex: 1,
    take: 10,
    search: '',
  };
  notesFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 1,
    take: 10,
    search: '',
  };
  usersFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 0,
    take: 300,
    state: States.Active,
    search: '',
  };
  pageNav: PaginationNavigationComponent;
  showPopup = false;
  filterUserList: User[] = [];
  userList: User[] = [];
  keyEnterPressed = false;
  selectedIndex = 0;
  clickedFromPopup = false;
  mentionRoleUserIdList: string[] = [];
  mentionUserNameList: string[] = [];
  mentionUserRoleNameList: string[] = [];
  mentionUserIdList: string[] = [];
  isFileUploaded = false;

  hrLookupCode = busLookups.NoteType;
  noteTypeId = '';
  /** Bound to Notes Type dropdown when a default or user selection is active. */
  selectedNoteTypeId: string | null = null;
  statusId = '';
  resolutionId = '';
  arrowdownPressd = false;
  arrowUpPressed = false;

  ticketStatusCode = lookupStatus;
  appRoles: PageResult<AppRoles> = new PageResult<AppRoles>();
  lookupModuleCOde = busLookupsModuleCode.TktStatus;
  lookupModuleResolutionCode = busLookupsModuleCode.Problem_Resolution;
  positionLat = 0;
  positionLog = 0;
  lastSavedStatus: string;
  resolutionList: BusLookup[] = [];
  statusList: BusLookup[] = [];
  statusListAll = [];
  resolutionListAll = [];
  noteTypeList: BusLookup[] = [];
  noteTypeListAll = [];
  timeZone: string;
  isUnderReview = false;
  isNoteSavedSuccess = false;
  reviewerUserId: string;
  lookupSetting: string[] = [];
  isFileUploadRequired = false;
  isCommentRequired = false;
  isReviewerRequired = false;
  isResolutionRequired = false;
  isCallStatusPageRefresh = false;

  @Input() isDisplayStatus = false;
  @Input() isDisplayNotes = false;

  @Input() notesWithStatus = false;
  isSelectedTabNotes = false;
  statusSearch = [];
  /** Bumped on tab switch so stale in-flight reloads are ignored. */
  private tabReloadSeq = 0;

  async setTab(tab: Tabs) {
    const seq = ++this.tabReloadSeq;
    this.activeTab = tab;
    this.isSelectedTabNotes = tab !== 'Status';
    await this.reloadData(seq);
    if (seq === this.tabReloadSeq) {
      this.refreshSaveButtonState();
    }
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab
      ? 'bg-[#FFFFFF] text-[#121212] border-[#42578A26]'
      : 'border-transparent';
  }
statusDropDownId: string[] = [];


  constructor(
    public authService: AuthService,
    private noteService: NotesService,
    private notifyService: NotifyService,
    public busService: BusLookupService,
    public fileService: FileService,
    private imageResize: ImageResizeService,
    public userService: UserService,
    public ticketLookupService: TktLookupService,
    private location: LocationService,
    private statusService: TicketStatusChangeService,
    private fb: FormBuilder,
    private fService:FileService,
    public utcToTimeZone: ConvertDateUtcTimezoneService,
    private hNotesServie: HNotesService
  ) {
    this.busLookupModuleCode = busLookupsModuleCode.NoteType;
    this.currentUserNameLetter = this.getShortName(this.authService.myName);
    this.initForm();
  }

  async ngOnInit() {
    this.ticketId = this.objectID;

    await this.reloadData();
    if (this.isDisplayNotes) {
      this.noteTypeList = await this.busService.getLookupDataByParentModuleCodeAndCategory(
        this.busLookupModuleCode,
        this.lookupCategoryCode
      );
      /*---- Sorting of the notes type start -----*/

      // 1️⃣ Filter parents that have children
        const parentsWithChildren = this.noteTypeList.filter(
          parent => parent.childLookup && parent.childLookup.length > 0
        );

        // 2️⃣ Sort parent names using your alphanumeric sorting function
        const sortedParentNames = this.sortAreasByAlphaNumeric(
          parentsWithChildren.map(parent => parent.name)
        );

        // 3️⃣ Flatten children in sorted parent order and sort children
        this.noteTypeListAll = sortedParentNames.flatMap(parentName => {
          const parent = parentsWithChildren.find(p => p.name === parentName);
          if (!parent) return [];

          // Sort child names alphanumerically
          const sortedChildNames = this.sortAreasByAlphaNumeric(
            parent.childLookup.map(child => child.name)
          );

          // Map sorted children
          return sortedChildNames.map(childName => {
            const child = parent.childLookup.find(c => c.name === childName);
            return {
              id: child!.id,
              name: child!.name,
              parentName: parent.name,
              // include other child properties if needed
            };
          });
        });

          /*---- Sorting of the notes type end -----*/

    }
    if (this.isDisplayStatus) {
      this.statusList = await this.busService.getLookupDataByParentModuleCode(
        this.lookupModuleCOde
      );

      /*---  Sorting of the status list ----*/

         // 1️⃣ Get parents that have children
          const parentsWithChildren = this.statusList.filter(
            parent => parent.childLookup && parent.childLookup.length > 0
          );

          // 2️⃣ Sort parent names (A → Z, then numbers)
          const sortedParentNames = this.sortAreasByAlphaNumeric(
            parentsWithChildren.map(parent => parent.name)
          );

          // 3️⃣ Flatten children in sorted parent order
          this.statusListAll = sortedParentNames.flatMap(parentName => {
            const parent = parentsWithChildren.find(p => p.name === parentName);
            if (!parent) return [];

            // 4️⃣ Sort child names
            const sortedChildNames = this.sortAreasByAlphaNumeric(
              parent.childLookup.map(child => child.name)
            );

            // 5️⃣ Map sorted children
            return sortedChildNames.map(childName => {
              const child = parent.childLookup.find(c => c.name === childName);
              return {
                id: child!.id,
                name: child!.name,
                parentName: parent.name,
              };
            });
          });

          /*---  Sorting of the status list ----*/

    }
    this.userService.getActiveUsers().then(users => {
      this.userList = users;
    });
    this.isSaveBtnDisabled = true;
  }



   private sortAreasByAlphaNumeric(names: string[]): string[] {
      return [...names].sort((a, b) => {
        // Extract letters
        const lettersA = a.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';
        const lettersB = b.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';

        // 1️⃣ Sort by letters
        if (lettersA !== lettersB) {
          return lettersA.localeCompare(lettersB);
        }

        // Extract numbers
        const numberA = parseInt(a.match(/\d+/)?.[0] || '0', 10);
        const numberB = parseInt(b.match(/\d+/)?.[0] || '0', 10);

        // 2️⃣ Sort by numbers
        return numberA - numberB;
      });
    }


  transformFlatToGrouped(flatData) {
    return flatData.filter((item) => {
      return (
        item.childLookup?.length > 0 ||
        flatData.some((parent) =>
          parent.childLookup?.some((child) => child.id === item.id)
        )
      );
    });
  }

  getAttachmentUrls(attachments: any[]): string[] {
    return attachments.map(x => x.attachmentUrl);
  }

  private async loadMongoNotes(noteTypeId?: string | null, seq?: number): Promise<void> {
    let mongoNotes: MongoNoteDetail[];
    const loadStatusNotes =
      this.notesWithStatus &&
      this.isDisplayNotes &&
      this.isDisplayStatus &&
      !this.isSelectedTabNotes;

    if (loadStatusNotes) {
      const notes = await this.hNotesServie.getNotesWithTicketStatus(this.objectID);
      if (seq != null && seq !== this.tabReloadSeq) return;
      mongoNotes = notes.map(mapMongoNoteWithTicketStatusToDetail);
    } else if (noteTypeId) {
      mongoNotes = await this.hNotesServie.getNotes(this.objectID, noteTypeId);
    } else {
      mongoNotes = await this.hNotesServie.getNotes(this.objectID);
    }
    if (seq != null && seq !== this.tabReloadSeq) return;
    this.mongoNotes = mongoNotes;
  }

  async reloadData(seq?: number) {
    const current = seq ?? ++this.tabReloadSeq;
    if (this.notesWithStatus) {
      this.filters = {
        pageIndex: 0,
        activeIndex: 1,
        take: 200,
        search: '',
      };
      if (this.isSelectedTabNotes) {
        await this.ensureDefaultNoteTypeSelected(current);
        if (current !== this.tabReloadSeq) return;
        await this.loadMongoNotes(this.noteTypeId || null, current);
      } else {
        const notes = await this.noteService.notesWithTicketStatus(
          this.filters,
          this.objectID
        );
        if (current !== this.tabReloadSeq) return;
        this.notes = notes;
        await this.loadMongoNotes(undefined, current);
      }
    } else {
      await this.loadMongoNotes(undefined, current);
    }
  }

  initForm() {
    this.form = this.fb.group({
      description: ['', [Validators.maxLength(500)]],
    });
  }

  getFileExtension(path: string): string {
    const ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase();
    return ext;
  }

   getFileIcon(path: string): string {
    const ext = this.getFileExtension(path);
    switch (ext) {
      case 'pdf': return './assets/images/icons/files/pdf.svg';
      case 'doc':
      case 'docx': return './assets/images/icons/files/doc.svg';
      case 'xls':
      case 'xlsx': return './assets/images/icons/files/excel.svg';
      case 'jpg':
      case 'jpeg': return './assets/images/icons/files/jpeg.svg';
      case 'png': return './assets/images/icons/files/png.svg';
      case 'heic': return './assets/images/icons/files/heic.svg';
      default: return './assets/images/icons/files/file.svg';
    }
  }



  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.isCompletedSelected = this.isCompleted;
    if (changes && this.isRefreshFromParent) {
      await this.fillNoteOnChange();
      await this.fillSelectedStatuses();
    }
  }
  async fillNoteOnChange() {
    const notesDataStatus = await this.noteService.notesWithTicketStatus(
      this.filters,
      this.objectID
    );
    const length = notesDataStatus.length - 1;
    const noteWithAtt = notesDataStatus[length];
    this.lastNote.emit(noteWithAtt);
  }
  getShortName(name: string) {
    if (name != undefined) {
      const nameArr = name.split(' ');
      const firstInitial = nameArr[0].charAt(0);
      const secondInitial = nameArr[1].charAt(0);

      return `${firstInitial}${secondInitial}`;
    } else {
      return 'D';
    }
  }

  async onChangeStatus(event: string ) {
    this.statusId = event;
    this.isUnderReview = false;
    this.reviewerUserId = undefined;
    this.resolutionId = undefined;
    this.isResolutionRequired = false;
    this.isCompletedSelected = false;
    if (!this.statusId) {
      this.refreshSaveButtonState();
      return;
    }
    if (this.selectedCurrentStatusId === this.statusId) {
      this.isSaveBtnDisabled = true;
      return;
    }
    this.noteTypeId = null;
    this.selectedNoteTypeId = null;

    const matchedChild = this.statusList
      .map((entry) => entry.childLookup || []) // Map to childLookup arrays or empty arrays
      .reduce((acc, val) => acc.concat(val), []) // Flatten the arrays
      .find((child) => child.id === this.statusId); // Find the first child with the matching id
    this.isFileUploadRequired = false;
    this.isCommentRequired = false;
    const lookupSetting = matchedChild.setting
      ? JSON.parse(matchedChild.setting.toString()): null;
    this.isFileUploadRequired = lookupSetting?.isFileUpload;
    this.isCommentRequired = lookupSetting?.isComment;
    this.isResolutionRequired = lookupSetting?.selectResolution;
    this.isReviewerRequired = lookupSetting?.selectReviewer;
    if (this.isResolutionRequired) {
      this.resolutionList =
        await this.busService.getLookupDataByParentModuleCode(
          this.lookupModuleResolutionCode
        );
      this.resolutionListAll = this.resolutionList
        .filter((parent) => parent.childLookup && parent.childLookup.length > 0) // Ensure parent has children
        .flatMap((parent) =>
          parent.childLookup.map((child) => ({
            id: child.id,
            name: child.name,
            parentName: parent.name,
          }))
        );
    } else if (matchedChild?.code === lookupStatus.UNDRREVIW.toString()) {
      this.isUnderReview = true;
    }
    if (matchedChild?.code === lookupStatus.COMPL.toString()){
      this.isCompletedSelected = true;
    }

    this.refreshSaveButtonState();
  }

  onChangeResolution(event: string) {
    this.resolutionId = event;
    this.refreshSaveButtonState();
  }

  private getDefaultNoteTypeId(): string | null {
    const first = this.noteTypeListAll?.[0];
    return first?.id != null ? String(first.id) : null;
  }

  /** Select the first note type when none is chosen (e.g. switching from Status tab). */
  private async ensureDefaultNoteTypeSelected(tabSeq?: number): Promise<void> {
    if (!this.isDisplayNotes || !this.noteTypeListAll?.length) {
      return;
    }
    const defaultId = this.getDefaultNoteTypeId();
    if (!defaultId) {
      return;
    }
    if (!this.noteTypeId) {
      this.selectedNoteTypeId = defaultId;
      this.noteTypeId = defaultId;
      if (tabSeq == null) {
        await this.onChangeNotes(defaultId);
      }
      return;
    }
    this.selectedNoteTypeId = this.noteTypeId;
  }

  async onChangeNotes(event: string) {
    this.noteTypeId = event;
    this.selectedNoteTypeId = event || null;
    this.statusId = null;
    this.refreshSaveButtonState();
    await this.loadMongoNotes(this.noteTypeId || null);
  }

  onInputChange(): void {
    const text = this.messageInput.nativeElement.value;
    this.isSaveBtnDisabled = this.shouldDisableSaveButton(text);
    this.handleMentionLogic(text);
  }

  private refreshSaveButtonState(): void {
    const text = this.messageInput?.nativeElement?.value ?? '';
    this.isSaveBtnDisabled = this.shouldDisableSaveButton(text);
  }

  private shouldDisableSaveButton(text: string): boolean {
    if (text.length === 0) return true;

    if (this.notesWithStatus && this.isDisplayNotes && this.isDisplayStatus) {
      if (this.isSelectedTabNotes) {
        return !this.noteTypeId;
      }
      if (!this.statusId) return true;
      if (this.selectedCurrentStatusId === this.statusId) return true;
      return false;
    }

    return false;
  }

  private handleMentionLogic(text: string): void {
    const matches = text.match(/@(\w+)/g);
    let lastMentionText: string | null = null;

    if (text.endsWith('@')) {
      this.showPopup = true;
      this.filterUserList = this.userList;
      return;
    }

    if (matches) {
      const lastWord = text.split(' ').pop() || '';
      if (lastWord.includes('@')) {
        this.handlePopupDisplay();
      } else {
        this.resetPopupState();
      }

      const lastMatch = matches[matches.length - 1];
      lastMentionText = lastMatch.slice(1); // Remove @ symbol

      this.filterUserList = this.userList.filter((name) =>
        name.fullName.toLowerCase().includes(lastMentionText!.toLowerCase())
      );

      this.scrollSelectedItemIntoView();
    } else {
      this.handleNoMatchPopup(text);
    }
  }

private handlePopupDisplay(): void {
  if (this.keyEnterPressed) {
    this.showPopup = false;
    this.selectedIndex = 0;
    this.keyEnterPressed = false;
  } else {
    this.showPopup = true;
  }
  this.scrollSelectedItemIntoView();
}

private resetPopupState(): void {
  this.selectedIndex = 0;
  this.showPopup = false;
}

private handleNoMatchPopup(text: string): void {
  if (text.includes('@')) {
    this.showPopup = true;
    this.filterUserList = this.userList;
    this.selectedIndex = 0;
  } else {
    this.resetPopupState();
  }
}

  scrollSelectedItemIntoView() {
    const container = document.querySelector('.list-container'); // Replace with your container selector
    const selectedItem = container?.children[this.selectedIndex]; // Get the currently selected item

    if (selectedItem) {
      const containerRect = container.getBoundingClientRect();
      const itemRect = selectedItem.getBoundingClientRect();

      // Check if the item is out of view and scroll it into view
      if (itemRect.bottom > containerRect.bottom) {
        // Item is overflowing at the bottom
        container.scrollTop += itemRect.bottom - containerRect.bottom;
      } else if (itemRect.top < containerRect.top) {
        // Item is overflowing at the top
        container.scrollTop -= containerRect.top - itemRect.top;
      }
    }
  }

  onSelectName(name: string, id: string, rolePerson: boolean) {
    const lastAtIndex = this.messageInput.nativeElement.value.lastIndexOf('@');
    if (lastAtIndex !== -1) {
      const words = this.messageInput.nativeElement.value.split(' ');
      const lastWord = words[words.length - 1];
      if (lastWord.includes('@')) {
        this.messageInput.nativeElement.value =
          this.messageInput.nativeElement.value.substring(0, lastAtIndex) +
          '@' +
          name;
        this.clickedFromPopup = true;
      }
      if (rolePerson === true) {
        this.mentionRoleUserIdList.push(id);
        this.mentionUserRoleNameList.push(name);
      } else {
        this.mentionUserIdList.push(id);
        this.mentionUserNameList.push(name);
      }
    }
    this.showPopup = false;


  }


@HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      this.arrowdownPressd = true;
      this.selectNextItem();
      event.preventDefault();
      this.scrollSelectedItemIntoView();
    } else if (event.key === 'ArrowUp') {
      this.arrowUpPressed = true;
      this.selectPreviousItem();
      event.preventDefault();
      this.scrollSelectedItemIntoView();
    } else if (event.key === 'Enter') {
      this.clickSelectedItem();
      this.selectedIndex = 0;
      this.showPopup = false;
      this.keyEnterPressed = true;
      if (this.clickedFromPopup) {
        event.preventDefault();
        this.clickedFromPopup = false;
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const inputEl = this.messageInput?.nativeElement;
    const popupEl = this.popupContainer?.nativeElement;
    const target = event.target as Node;

    const clickedInsideInput = inputEl?.contains(target);
    const clickedInsidePopup = popupEl?.contains(target);

    if (!clickedInsideInput && !clickedInsidePopup) {
      this.showPopup = false;
    }
  }



  selectNextItem() {
    if (this.selectedIndex < this.filterUserList.length - 1) {
      this.selectedIndex++;
    }
  }
  selectPreviousItem() {
    if (this.selectedIndex > 0) {
      this.selectedIndex--;
    }
  }
  clickSelectedItem() {
    const selectedUser = this.filterUserList[this.selectedIndex];
    if (selectedUser) {
      this.onSelectName(
        selectedUser.fullName,
        selectedUser.id,
        selectedUser.isRolePerson
      );
    }
    this.showPopup = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async handleFileInput(event: any): Promise<void> {
    const files: File[] = Array.from(event.target.files);
    const existingFiles: File[] = Array.from(this.lstFiles ?? []);
    const existingFileNames = new Set(existingFiles.map(file => file.name));

    const {
      validFiles,
      skippedUnsupportedFiles,
      skippedDuplicateFiles
    } = this.filterValidFiles(files, existingFileNames);

    const {
      acceptedFiles,
      skippedExtraFiles
    } = this.enforceFileLimit(validFiles, existingFiles.length);

    const { imageFiles, otherFiles } = this.separateImageFiles(acceptedFiles);

    const resizedImages = await this.resizeImages(imageFiles);
    this.resizedFiles = resizedImages.filter(file => file !== null);

    this.lstFiles = existingFiles.concat(this.resizedFiles, otherFiles);
    this.isuploadDocument = false;

    this.updateUploadedFiles(this.lstFiles);
    if(this.isTextRequired) {
      this.validateSaveButtonState();

    }else{
      this.isSaveBtnDisabled = false;
      if(this.isSelectedTabNotes && !this.noteTypeId){
        this.isSaveBtnDisabled = true;
      }
      if(this.selectedCurrentStatusId === this.statusId){
        this.isSaveBtnDisabled = true;
      }
    }

    this.showSkippedFileErrors({
      skippedDuplicateFiles,
      skippedUnsupportedFiles,
      skippedExtraFiles
    });

    event.target.value = '';
  }

  private filterValidFiles(files: File[], existingFileNames: Set<string>) {
    const validFiles: File[] = [];
    const skippedUnsupportedFiles: string[] = [];
    const skippedDuplicateFiles: string[] = [];

    for (const file of files) {
      if (!this.isSupported(file)) {
        skippedUnsupportedFiles.push(file.name);
      } else if (existingFileNames.has(file.name)) {
        skippedDuplicateFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    }

    return { validFiles, skippedUnsupportedFiles, skippedDuplicateFiles };
  }

  private isSupported(file: File): boolean {
    const supportedTypes = [
      FileMimeType.JPEG,
      FileMimeType.PNG,
      FileMimeType.HEIC,
      FileMimeType.HEIF,
      FileMimeType.PDF,
      FileMimeType.DOC,
      FileMimeType.DOCX,
      FileMimeType.XLS,
      FileMimeType.XLSX,
    ];

    const supportedExtensions: FileExtension[] = [
      FileExtension.JPG,
      FileExtension.JPEG,
      FileExtension.PNG,
      FileExtension.HEIC,
      FileExtension.HEIF,
      FileExtension.PDF,
      FileExtension.DOC,
      FileExtension.DOCX,
      FileExtension.XLS,
      FileExtension.XLSX,
    ];
    const ext = file.name.split('.').pop()?.toLowerCase();

    return supportedTypes.includes(file.type  as FileMimeType) || (ext && supportedExtensions.includes(`.${ext}` as FileExtension));
  }

  private enforceFileLimit(files: File[], existingCount: number) {
    const maxFiles = 10;
    const allowed = maxFiles - existingCount;

    return {
      acceptedFiles: files.slice(0, allowed),
      skippedExtraFiles: files.slice(allowed).map(file => file.name)
    };
  }

  private separateImageFiles(files: File[]) {
    const imageTypes = [FileMimeType.JPEG,
      FileMimeType.PNG,
      FileMimeType.HEIC,
      FileMimeType.HEIF];
    const imageFiles = files.filter(file => imageTypes.includes(file.type  as FileMimeType));
    const otherFiles = files.filter(file => !imageTypes.includes(file.type as FileMimeType));
    return { imageFiles, otherFiles };
  }

  private resizeImages(imageFiles: File[]): Promise<(File | null)[]> {
    return Promise.all(
      imageFiles.map(file => this.imageResize.resizeImage(file, 800, 800, 0.7))
    );
  }

  private updateUploadedFiles(files: File[]): void {
    for (const file of files) {
      if (!this.isSupported(file)) continue;

      const uploadItem = new IFileUpload();
      uploadItem.AttachmentName = file.name;
      uploadItem.AttachmentBlobName = 'notfound';
      this.lstUploadedFiles.push(uploadItem);

      this.totalFileSize += file.size;
      this.isuploadDocument = this.totalFileSize <= 4194304;
    }

    // Remove duplicates by name
    this.lstUploadedFiles = this.lstUploadedFiles.filter(
      (file, index, self) =>
        index === self.findIndex(f => f.AttachmentName === file.AttachmentName)
    );

  }

  private validateSaveButtonState(): void {
    const text = this.messageInput.nativeElement.value;
    if (this.lstUploadedFiles.length === 0 || text.length === 0) {
      this.isSaveBtnDisabled = true;
      return;
    }

    if (this.notesWithStatus && this.isDisplayNotes && this.isDisplayStatus) {
      if (this.isSelectedTabNotes) {
        this.isSaveBtnDisabled = !this.noteTypeId;
      } else {
        this.isSaveBtnDisabled = !this.statusId;
      }
    } else {
      this.isSaveBtnDisabled = false;
    }
  }

  private showSkippedFileErrors(data: {
    skippedDuplicateFiles: string[],
    skippedUnsupportedFiles: string[],
    skippedExtraFiles: string[]
  }): void {
    const { skippedDuplicateFiles, skippedUnsupportedFiles, skippedExtraFiles } = data;

    if (skippedDuplicateFiles.length > 0) {
      this.errorNotification(
        `The following files were already selected and have been skipped: ${skippedDuplicateFiles.join(', ')}`,
        'Duplicate Files Skipped'
      );
    }

    if (skippedUnsupportedFiles.length > 0) {
      this.errorNotification(
        `The following files have unsupported formats and were skipped: ${skippedUnsupportedFiles.join(', ')}`,
        'Unsupported File Type(s)'
      );
    }

    if (skippedExtraFiles.length > 0) {
      this.errorNotification(
        `Only 10 files can be uploaded at a time. The following files were skipped: ${skippedExtraFiles.join(', ')}`,
        'Upload Limit Exceeded'
      );
    }
  }





  resizeImage(
        file: File,
        maxWidth: number,
        maxHeight: number,
        quality: number
      ): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const originalWidth = img.width;
        const originalHeight = img.height;
        let targetWidth = originalWidth;
        let targetHeight = originalHeight;

        if (originalWidth > originalHeight) {
          if (originalWidth > maxWidth) {
            const scale = maxWidth / originalWidth;
            targetWidth = maxWidth;
            targetHeight = Math.round(originalHeight * scale);
          }
        } else {
          if (originalHeight > maxHeight) {
            const scale = maxHeight / originalHeight;
            targetHeight = maxHeight;
            targetWidth = Math.round(originalWidth * scale);
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('Failed to get canvas context'));

        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('Failed to create image blob'));
            const resizedFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(resizedFile);
          },
          'image/jpeg',
          quality
        );
      };

      img.onerror = (err) => reject(err);
    });
  }

  truncateFileName(filePath: string): string {
    const urlParts = filePath.split('/');
    const fullFileName = urlParts[urlParts.length - 1]; // Get last part of the path
    const maxLength = 15;
    const fileType = fullFileName.split('.').pop(); // file extension
    const fileNameWithoutExt = fullFileName.substring(0, fullFileName.lastIndexOf('.'));

    return fullFileName.length > maxLength
      ? fileNameWithoutExt.slice(0, maxLength - 2) + '....' + fileType
      : fullFileName;
  }

  async resetNote() {
    this.messageInput.nativeElement.value = '';
    this.messageInput.nativeElement.readOnly = false;
    this.startDate = '';
    this.endDate = '';
    this.search = '';
    this.editCheck = false;
    this.isSaveBtnDisabled = true;
    this.lstUploadedFiles = [];
    this.existingUploadedFiles = [];
    this.lstFiles = [];
    this.isFileUploaded = false;
    this.mentionRoleUserIdList = [];
    this.mentionUserNameList = [];
    this.mentionUserRoleNameList = [];
    this.mentionUserIdList = [];
  }

  notetype(type) {
    return type;
  }

  edit(item: Notes) {
    this.messageInput.nativeElement.value = item.noteText;
    this.messageInput.nativeElement.readOnly = false;
    this.isSaveBtnDisabled = false;
    this.editCheck = true;
    this.editNote = item;
    this.lstUploadedFiles = [];
    this.existingUploadedFiles = [];
    item.attachments.forEach((x) => {
      const uploadItem = new IFileUpload();
      uploadItem.AttachmentName = this.getFileName(x.path) as string;
      uploadItem.AttachmentBlobName = x.path as string;
      this.lstUploadedFiles.push(uploadItem);
      this.existingUploadedFiles.push(uploadItem);
    });
  }

  notesLookup$: Observable<PageResult<Notes>>;
  findNoteById(id: string): Observable<Notes | undefined> {
    return this.notesLookup$.pipe(
      map((pageResult) => {
        // Check if data exists and is an array
        if (pageResult.data && Array.isArray(pageResult.data)) {
          // Find the note with the given ID
          return pageResult.data.find((note) => note.id === id);
        } else {
          return undefined;
        }
      })
    );
  }

  checkUploadFile(): boolean {
    this.isFileUploaded = true;
    return this.isFileUploaded;
  }


  async OnSubmit(id?: string) {

        if (this.messageInput.nativeElement.readOnly) return;

        if (!this.validateInputs()) return;
        if (!this.resolutionValidationError()) return;

        let myObjectID = id || this.objectID;

        if (!id && this.isDisplayStatus && !this.isSelectedTabNotes) {
          myObjectID = this.statusId;
        }

        const newCommentMessage = this.buildNoteObject(myObjectID);

        this.loading = true;

        if (this.editCheck) {
          await this.updateExistingNote(newCommentMessage);
        } else {
          await this.saveNewNote(newCommentMessage);
        }

        if (!this.isManager && this.isStatusDropDown) {
          this.isCallStatusPageRefresh = true;
          this.fillSelectedStatuses();
        }
  }

  private validateInputs(): boolean {
    const text = this.messageInput.nativeElement.value;

    if (this.lstUploadedFiles.length > 0 && text === '') return true;

    if (text.length > 500) {
      this.setError('Description should be less than 500 character.', 'Length Error');
      return false;
    }

    if (this.isDisplayNotes && this.isSelectedTabNotes && !this.noteTypeId) {
      this.setError('Please select note type.', 'Note Type Error');
      return false;
    }

    if (this.isDisplayStatus && !this.isSelectedTabNotes && !this.statusId) {
      this.setError('Please select status.', 'Status Error');
      return false;
    }

    if (!text.trim() && (this.lstFiles.length <= 0 || this.isCommentRequired) && (this.isCommentRequired || this.isTextRequired)) {
      this.setError('Please enter description.', 'Description Error');
      return false;
    }

    if (this.lstFiles.length <= 0 && this.isFileUploadRequired) {
      this.setError('Please attach relevant files.', 'Attachment Error');
      return false;
    }

    if (this.isUnderReview && !this.reviewerUserId) {
      this.setError('Please select Reviewer.', 'Selection Error');
      return false;
    }

    return true;
  }

  resolutionValidationError(){
    if (this.isResolutionRequired && !this.resolutionId) {
      this.setError('Please select problem resolution.', 'Selection Error');
      return false;
    }
    return true;

  }

  private async updateExistingNote(note: Notes) {
    this.editNote.noteText = note.noteText;
    this.editNote.files = this.lstFiles!;
    this.editNote.noteModuleCode = note.noteModuleCode;
    this.editNote.businessId = note.businessId;
    this.editNote.updatedById = note.updatedById;
    this.editNote.noteTypeId = note.noteTypeId;

    this.isSaveBtnDisabled = true;

    try {
      await this.noteService.updateNote(
        this.editNote,
        this.lstUploadedFiles,
        this.existingUploadedFiles,
        this.lstFiles
      );
      this.showSuccessMessage();
      this.resetAfterSave();
    } catch (err) {
      this.showErrorMessage(err);
    }
  }

  // Helper function to get local date in 24-hour format
  getLocalDate24Hour(newDate?: Date): string {

    const localDate = newDate ?? new Date();

    const formattedDate =
      `${(localDate.getMonth() + 1).toString().padStart(2,'0')}/` +
      `${localDate.getDate().toString().padStart(2,'0')}/` +
      `${localDate.getFullYear()} ` +
      `${localDate.getHours().toString().padStart(2,'0')}:` +
      `${localDate.getMinutes().toString().padStart(2,'0')}:` +
      `${localDate.getSeconds().toString().padStart(2,'0')}`;

    return formattedDate;
  }

  private async saveNewNote(note: Notes) {
    try {
      if (this.isDisplayStatus && this.statusId) {
        const success = await this.trySaveStatusChange(note);
        if (!success) return;
      }

      await this.noteService.addNote(note, this.lstFiles, this.mentionUserIdList);
      this.isCompleted = false;
      if(this.isCompletedSelected){
        this.isCompleted = true;
      }
      this.isTicketCompleted.emit(this.isCompleted);
      if (this.isDisplayStatus && this.statusId) {

        this.selectedCurrentStatusId = this.statusId;
      }
      this.showSuccessMessage();
      this.reloadData();
      this.lastSavedStatus = this.statusId;
      this.isChangeAvailable.emit(true);
      await this.resetNote();
    } catch (err) {
      await this.handleSaveError(err);
    } finally {
      this.loading = false;
      this.refreshSaveButtonState();
    }
  }

 private async trySaveStatusChange(note: Notes): Promise<boolean> {
    if (!this.assigneeId) {
      this.assigneeId = '00000000-0000-0000-0000-000000000000';
    }
    if (this.lastSavedStatus === this.statusId) {
      this.setError('You recently saved same status. Please select different status.', 'Error');
      this.loading = false;
      return false;
    }

    const status = new TicketStatusChange();
    status.assignedUserId = this.isUnderReview ? this.reviewerUserId : this.assigneeId;
    status.changeById = this.authService.id;
    status.changeOn = new Date();
    status.changeStatusId = this.statusId;
    status.description = this.resolutionId;
    status.latitude = this.positionLat.toString();
    status.longitude = this.positionLog.toString();
    status.ticketId = this.objectID;

    try {
      const id = await this.statusService.addTicketStatus(status);
      note.objectID = id;
      return true;
    } catch {
      let errorType: string;
      if (this.isStatusDropDown) {
        errorType = 'ticket status';
      } else if (this.isNoteType) {
        errorType = 'notes';
      } else {
        errorType = 'description';
      }

      this.showErrorMessage('Failed to add ' + errorType);
      this.loading = false;
      return false;
    }
  }


  private async handleSaveError(
      err: Blob | { error?: { message?: string }; message?: string } | Error | unknown
    ) {
      if (err instanceof Blob && err.type === 'application/json') {
        const text = await err.text();
        try {
          const json = JSON.parse(text);
          this.showErrorMessage(json.message || 'Failed to save note (Blob error).');
        } catch {
          this.showErrorMessage('An unknown error occurred during file upload.');
        }
        return;
      }

      // Narrow unknown/other error types
      if (err && typeof err === 'object') {
        const e = err as { error?: { message?: string }; message?: string };
        this.showErrorMessage(
          e.error?.message || e.message || 'An unexpected error occurred while saving the note.'
        );
        return;
      }

      this.showErrorMessage('An unexpected error occurred while saving the note.');
    }


  private resetAfterSave() {
    this.loading = false;
    this.resetNote();
    this.refreshSaveButtonState();
  }


  private setError(msg: string, title: string) {
    this.errorNotification(msg, title);
    this.isSaveBtnDisabled = true;
  }

  private buildNoteObject(myObjectID: string): Notes {
    let resolutionName = '';
    if (this.isResolutionRequired && this.resolutionId) {
        resolutionName = this.resolutionListAll.filter(x=> x.id === this.resolutionId)[0]?.name;
    }
    // updateDate=this.utcToTimeZone.convertLocalTimeToUTC(new Date(),this.parentTimeZone)
    return {
      id: '0',
      objectID: myObjectID,
      noteModuleCode: this.noteModuleCode,
      TicketId: this.ticketId,
      noteText: (resolutionName? resolutionName + ' | ' : '') + this.messageInput.nativeElement.value,
      updatedOn: this.getLocalDate24Hour(this.utcToTimeZone.convertLocalTimeToUTC(new Date(), this.parentTimeZone)),
      attachment: false,
      businessId: this.authService.businessId,
      updatedById: this.authService.id,
      noteTypeId: this.noteTypeId,
      mentionUserIdList: this.mentionUserIdList,
    };
  }


  showSuccessMessage() {
    this.notifyService.success({
      crud: this.editCheck ? UserAction.Crud.update : UserAction.Crud.create,
      object: this.isStatusDropDown ? SystemObject.status : SystemObject.notes,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showErrorMessage(error: any) {
      error = error.graphQLErrors? error.graphQLErrors[0]: error;
      this.notifyService.error({
        message: error.message,
        type: error.extensions? error.extensions.type: 'Error',
      });
  }


  errorNotification(eMessage: string, eType: string) {
    this.notifyService.error({
      message: eMessage,
      type: eType,
    });
  }

  downloadNoteFile(event: string) {
    this.noteService.downloadMyFile(event);
  }

  getFileName(fullpath: string): string {
    return fullpath.split('/').pop()!;
  }

  async setCurrentLocation() {
    try {
      const position = await this.location.getCurrentLocation() as GeoPosition;

      this.positionLat = position.lat;
      this.positionLog = position.lng;

    } catch (error) {
      console.error('Error getting location', error);
      this.positionLat = 0;
      this.positionLog = 0;
    }
  }

  remove(filename: string): void {
    this.lstUploadedFiles = this.lstUploadedFiles.filter(
      (e) => e.AttachmentName !== filename
    );
    this.lstFiles = this.lstFiles.filter((e) => e.name !== filename);
  }

  async switchPage(pageSize?: number) {
    if (pageSize) {
      this.filters.take = pageSize;
      this.filters.pageIndex = 0;
      this.filters.activeIndex = 1;
    }
  }

  async previousPage(pageIndex: number) {
    this.filters.pageIndex = pageIndex;
    this.switchPage();
  }

  async showImageViewer(images: string[], index: number) {
    this.loading = true;
    const filePath = images[index];
    const fileExt = this.getFileExtension(filePath);

    // For pdf/doc/docx/heic → download
    if (["pdf", "doc", "docx", "heic"].includes(fileExt)) {
      this.downloadNoteFile(filePath);
      this.loading = false;
      return;
    }

    // Otherwise → filter images
    const filteredImages = images.filter(img => {
      const ext = this.getFileExtension(img);
      return !["pdf", "doc", "docx", "heic"].includes(ext);
    });

    // Find new index in filteredImages
    const filteredIndex = filteredImages.indexOf(filePath);

    this.loading = false;
    this.fService.viewImage(filteredImages, filteredIndex);
  }



  async nextPage(pageIndex: number) {
    this.filters.pageIndex = pageIndex;
    this.switchPage();
  }

  async pageSelected(pageIndex: number) {
    this.filters.pageIndex = pageIndex;
    this.switchPage();
  }

  getAttachmentPaths(attachments: NoteAttachments[] = []): string[] {
    return attachments.map(a => a.path);
  }

  openImageViewer(att: NoteAttachments[]) {
    const attArray: string[] = [];
    let i = 0;
    att.forEach((x) => {
      attArray[i] = x.path;
      i++;
    });
    this.fileService.viewImage(attArray);
  }

  async fillSelectedStatuses() {
    const ticketStatus = this.latestChangeStatus;
    this.lookupSetting = [];

    const setting = ticketStatus?.statusLookup?.setting
      ? JSON.parse(ticketStatus.statusLookup.setting.toString()).nextStatusIds
      : null;
    if (setting && setting.length > 0) {
      this.lookupSetting = setting;
      await this.ticketLookupService.fetchBussinessLookupWithIN(true, setting);
    }
  }

  calculatedNotesUploadTime(updatedOnStr: string): string {
    const [datePart, timePart, ampm] = updatedOnStr.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [rawHours, minutes, seconds] = timePart.split(':').map(Number);
    let hours = rawHours;

    if (ampm.toLowerCase() === 'pm' && hours < 12) hours += 12;
    if (ampm.toLowerCase() === 'am' && hours === 12) hours = 0;

    // Construct a string that JS can parse as local time
    const formattedDateStr = `${year}-${month.toString().padStart(2, '0')}-${day
      .toString()
      .padStart(2, '0')}T${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    const updatedOn = new Date(formattedDateStr); // consistent local datetime
    const now = new Date();

    const diffMs = now.getTime() - updatedOn.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    if (diffHours < 24) {
      return `${diffHours} hours`;
    } else {
      return updatedOnStr; // fallback to original
    }
  }

  parseCustomDateString(dateStr: string): Date | undefined {
    const [datePart, timePart, ampm] = dateStr.trim().split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [rawHours, minutes, seconds] = timePart.split(':').map(Number);
    let hours = rawHours;
    if (ampm?.toLowerCase() === 'pm' && hours < 12) hours += 12;
    if (ampm?.toLowerCase() === 'am' && hours === 12) hours = 0;

    const formatted = `${year}-${String(month).padStart(2, '0')}-${String(
      day
    ).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(
      minutes
    ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    const parsedDate = new Date(formatted);
    return isNaN(parsedDate.getTime()) ? undefined : parsedDate;
  }

}
